import { useUIStore } from '@/app/model';
import { createTask } from '@/entities/task/api/tasks';
import { invalidateTaskCaches } from '@/features/tasks/model/useTaskActions';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

type CreateMeetingTaskParams = {
  deadlineISO: string;
  onClose: () => void;
  payload: ANY;
  selectedDuration: 30 | 60;
};

export function useCreateMeetingTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ payload }: CreateMeetingTaskParams) => createTask(payload),
    onSuccess: (_data, variables) => {
      // Не ждём refetch — invalidateQueries резолвится только после того как
      // отработают все подписанные запросы, из-за этого закрытие модалки
      // подвисало на несколько секунд. Кэш обновится в фоне.
      invalidateTaskCaches(queryClient);

      useUIStore.getState().setMeetingTasks([
        ...useUIStore.getState().meetingTasks,
        {
          id: Date.now(),
          dueDate: variables.deadlineISO,
          isMeeting: true,
          TIME_ESTIMATE: variables.selectedDuration * 60,
        } as ANY,
      ]);

      toast.success('Встреча создана');
      variables.onClose();
    },
    onError: (error) => {
      console.error('create meeting error:', error);
      toast.error('Не смог создать задачу');
    },
  });
}
